import { withChartLayout } from 'components/common';
import DoNotResuscitate from 'components/features/chart/special-charts/do-not-resuscitate/DoNotResuscitate';

const DoNotResuscitatePage = withChartLayout('Do Not Resuscitate')(DoNotResuscitate);
export default DoNotResuscitatePage;
